<template>
  <div class="custom-actions">
    <a
      v-if="
        rowData.status.valor != 3 &&
        rowData.statusProcessoExpedicao.valor == 1
      "
      v-b-tooltip
      title="Editar"
      @click="$emit('edit', rowData)"
      ><i class="fa fa-truck"></i
    ></a>
    <a
      v-if="
        rowData.status.valor != 3 &&
        rowData.statusProcessoExpedicao.valor == 1 &&
        getPermissionFw('expedicao.escanear.volumes')
      "
      v-b-tooltip
      title="Escanear volumes"
      @click="$emit('create-scan', rowData.cargaId)"
      ><i class="fa fa-barcode"></i
    ></a>
    <a
      v-b-tooltip
      title="Checar CTes da carga"
      @click="$emit('checagem-cte', rowData.cargaId)"
      ><i class="fa fa-barcode"></i
    ></a>
    <a
      v-b-tooltip
      title="Checar NFs da carga"
      @click="$emit('checagem-nfs', rowData.cargaId)"
      ><i class="fa fa-barcode"></i
    ></a>
    <a
      v-if="
        getPermissionFw('expedicao.store') &&
        rowData.status.valor != 3 &&
        rowData.statusProcessoExpedicao.valor == 1 &&
        rowData.pessoa !== null &&
        !hasPendingWatcherAlert(rowData)
      "
      v-b-tooltip
      title="Confirmar Expedição"
      @click="
        $emit('store', {
          cargaId: rowData.cargaId,
          cargaMeioTransp: rowData.cargaMeioTransp,
          numCarga: rowData.numCarga,
        })
      "
      ><i class="fa fa-check"></i
    ></a>
    <a
      v-if="
        rowData.status.valor != 3 &&
        rowData.statusProcessoExpedicao.valor == 1
      "
      v-b-tooltip
      title="Cancelar montagem de carga"
      @click="$emit('cancel-montagem', rowData.cargaId)"
      ><i class="fa fa-times"></i
    ></a>
    <a
      v-if="
        getPermissionFw('gerenciamentotransporte.imprimir_romaneio') &&
        rowData.tpOperacaoPrincipal == 3 &&
        rowData.statusProcessoExpedicao.valor == 3 &&
        rowData.retira != 1
      "
      v-b-tooltip
      title="Imprimir Romaneio"
      @click="$emit('imprimir-romaneio', rowData)"
      ><i class="fa fa-print"></i
    ></a>
    <a
      v-if="
        rowData.statusProcessoExpedicao.valor == 3 && rowData.retira == 1
      "
      v-b-tooltip
      title="Imprimir Retira"
      @click="$emit('imprimir-romaneio', rowData)"
      ><i class="fa fa-print"></i
    ></a>
    <a
      v-if="
        getPermissionFw('gerenciamentotransporte.imprimir_romaneio') &&
          rowData.statusProcessoExpedicao.valor == 1 ||
        rowData.statusProcessoExpedicao.valor == 2
      "
      v-b-tooltip
      title="Imprimir Romaneio Provisório"
      @click="$emit('imprimir-provisorio', rowData)"
      ><i class="fa fa-print"></i
    ></a>
    <a
      v-if="
        rowData.statusProcessoExpedicao.valor == 3 &&
        hasManifestoImprimivel(rowData)
      "
      v-b-tooltip
      title="Imprimir Manifesto"
      @click="$emit('imprimir-manifesto', getManifestoIdsParaImpressao(rowData))"
      ><i class="fa fa-print"></i
    ></a>
    <a
      v-if="getPermissionFw('expedicao.store')"
      v-b-tooltip
      title="Sequenciar entrega"
      @click="$emit('sequencia', rowData.cargaId)"
      ><i
        v-if="
          rowData.status.valor != 3 &&
          rowData.statusProcessoExpedicao.valor == 1
        "
        class="fa fa-map-o"
      ></i
    ></a>
    <a
      v-if="
        getPermissionFw('expedicao.store') &&
        permiteGerarDoc &&
        rowData.status.valor != 1 &&
        rowData.retira != 1 &&
        rowData.statusProcessoExpedicao.valor == 3 &&
        (rowData.tpOperacaoPrincipal == 2 || rowData.interestadual == 1) &&
        (
          (rowData.manifesto == null || rowData.manifesto.status == 14 || rowData.manifesto.status != 6)
        )
      "
      v-b-tooltip
      title="Gerar Documento"
      @click="$emit('gerar-doc', rowData)"
      ><i class="fa fa-file-text"></i
    ></a>
    <a
      v-if="
        getPermissionFw('expedicao.store') &&
        rowData.status.valor != 1 &&
        rowData.retira != 1 &&
        rowData.statusProcessoExpedicao.valor == 3 &&
        rowData.statusIntegracoes.statusTargetPedagio.status.valor == 2
      "
      v-b-tooltip
      title="Comprar Pedagio avulso"
      @click="$emit('compra-pedagio', rowData)"
      ><i class="fa fa-car"></i
    ></a>
    <a
      v-if="showEndorsementIntegrationButton(rowData)"
      v-b-tooltip
      title="Integrar ATM"
      @click="$emit('integracao', { rowData, tipo: 1 })"
      ><i class="fa fa-money"></i
    ></a>
    <a
      v-if="showRoutingIntegrationButton(rowData)"
      v-b-tooltip
      title="Integrar Iroute"
      @click="$emit('integracao', { rowData, tipo: 2 })"
      ><i class="fa fa-map-pin"></i
    ></a>
    <a
      v-if="showTargetIntegrationButton(rowData)"
      v-b-tooltip
      title="Integrar roteiro target"
      @click="$emit('integracao', { rowData, tipo: 3 })"
      ><i class="fa fa-bullseye"></i
    ></a>
    <a
      v-if="
        getPermissionFw('expedicao.store') && rowData.cargaValePedagio != null
      "
      v-b-tooltip
      title="Cancelamento do Vale Pedágio"
      @click="$emit('integracao', { rowData, tipo: 6 })"
      ><i class="fa fa-window-close-o"></i
    ></a>
    <a
      v-if="
        getPermissionFw('expedicao.store') &&
        rowData.integracaoNstech.length > 0 &&
        ![1, 6].includes(rowData.statusExpedicaoNstech)
      "
      v-b-tooltip
      title="Cancelar carga na NSTech"
      @click="$emit('cancel-nstech', rowData)"
      ><i class="fa fa-times"></i
    ></a>
    <a
      v-if="showEstornaCalculoButton(rowData)"
      v-b-tooltip
      title="Estornar calculo"
      @click="$emit('estorna-calculo', rowData.cargaId)"
      ><i class="fa fa-window-close-o"></i
    ></a>
    <a
      v-if="showCiotIntegrationButton(rowData)"
      v-b-tooltip
      title="Integrar Ciot Target"
      @click="$emit('gera-ciot', rowData)"
      ><i class="fa fa-bullseye"></i
    ></a>
    <a
      v-if="
        rowData.statusProcessoExpedicao.valor != 1 &&
        rowData.statusExpedicaoDespesa != 2
      "
      v-b-tooltip
      title="Cancelar processo de Expedição"
      @click="$emit('cancel-expedicao', rowData)"
      ><i class="fa fa-times-circle"></i
    ></a>
    <a
      v-if="
        rowData.statusProcessoExpedicao.valor != 1 || rowData.consultaCompleta
      "
      v-b-tooltip
      title="Ver detalhes"
      @click="$emit('detail', rowData)"
      ><i class="fa fa-plus"></i
    ></a>
    <a
      v-if="showItrackIntegrationButton(rowData)"
      v-b-tooltip
      title="Reenviar Itrack"
      @click="$emit('reenviar-itrack', rowData.cargaId)"
      ><i class="fa fa-reply"></i
    ></a>
    <a
      v-if="showDocumentIntegrationButton(rowData)"
      v-b-tooltip
      title="Reenviar CTE"
      @click="$emit('validate-cte', rowData.cargaId)"
      ><i class="fa fa-reply"></i
    ></a>
    <a
      v-if="
        getPermissionFw('expedicao.store') && rowData.status.valor == 3
      "
      v-b-tooltip
      title="Reenviar MDFe Itrack"
      @click="$emit('reenviar-mdfe', rowData.manifesto.manifestoId)"
      ><i class="fa fa-reply"></i
    ></a>
    <a
      v-if="getPermissionFw('expedicao.reenvio.pesssoatransp')"
      v-b-tooltip
      title="Redefinir parceiro das notas fiscais"
      @click="$emit('reenvio-trn', rowData.cargaId)"
      ><i class="fa fa-user"></i
    ></a>
    <a
      v-b-tooltip
      title="Desagrupar carga"
      @click="$emit('desagrupa', rowData.cargaId)"
      ><i class="fa fa-object-ungroup"></i
    ></a>
    <a
      v-if="
        showExpanseIntegrationButton(rowData) &&
        !hasWatcherBlockingAlert(rowData)
      "
      v-b-tooltip
      title="Gerar carregamento despesa"
      @click="$emit('envia-frete-avulso', rowData)"
      ><i class="fa fa-cubes"></i
    ></a>
  </div>
</template>

<script>
import {
  getManifestoIdsParaImpressao,
  hasManifestoImprimivel,
  showCiotIntegrationButton as showCiotIntegrationButtonFn,
  showDocumentIntegrationButton as showDocumentIntegrationButtonFn,
  showEndorsementIntegrationButton as showEndorsementIntegrationButtonFn,
  showEstornaCalculoButton as showEstornaCalculoButtonFn,
  showExpanseIntegrationButton as showExpanseIntegrationButtonFn,
  showItrackIntegrationButton as showItrackIntegrationButtonFn,
  showRoutingIntegrationButton as showRoutingIntegrationButtonFn,
  showTargetIntegrationButton as showTargetIntegrationButtonFn,
} from "../utils/expedicaoRowVisibility";

export default {
  name: "ExpedicaoRowActions",
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    permiteGerarDoc: {
      type: Boolean,
      required: true,
    },
    permiteGerarDespesa: {
      type: Boolean,
      required: true,
    },
    watcherAlertShipmentIds: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  methods: {
    getManifestoIdsParaImpressao,
    hasManifestoImprimivel,
    perm(key) {
      return this.getPermissionFw(key);
    },
    showDocumentIntegrationButton(shipment) {
      return showDocumentIntegrationButtonFn(this.perm, shipment);
    },
    showCiotIntegrationButton(shipment) {
      return showCiotIntegrationButtonFn(this.perm, shipment);
    },
    showEstornaCalculoButton(shipment) {
      return showEstornaCalculoButtonFn(this.perm, shipment);
    },
    showExpanseIntegrationButton(shipment) {
      return showExpanseIntegrationButtonFn(
        this.perm,
        this.permiteGerarDespesa,
        shipment
      );
    },
    showTargetIntegrationButton(shipment) {
      return showTargetIntegrationButtonFn(this.perm, shipment);
    },
    showEndorsementIntegrationButton(shipment) {
      return showEndorsementIntegrationButtonFn(this.perm, shipment);
    },
    showItrackIntegrationButton(shipment) {
      return showItrackIntegrationButtonFn(this.perm, shipment);
    },
    showRoutingIntegrationButton(shipment) {
      return showRoutingIntegrationButtonFn(this.perm, shipment);
    },
    hasPendingWatcherAlert(shipment) {
      const shipmentId = Number(shipment && shipment.cargaId);
      const processStatus = Number(
        shipment &&
          shipment.statusProcessoExpedicao &&
          shipment.statusProcessoExpedicao.valor
      );

      if (!Number.isInteger(shipmentId) || shipmentId <= 0) {
        return false;
      }

      return (
        processStatus === 1 &&
        this.watcherAlertShipmentIds.includes(shipmentId)
      );
    },
    hasWatcherBlockingAlert(shipment) {
      const shipmentId = Number(shipment && shipment.cargaId);
      if (!Number.isInteger(shipmentId) || shipmentId <= 0) {
        return false;
      }

      return this.watcherAlertShipmentIds.includes(shipmentId);
    },
  },
};
</script>
